import React, { ReactNode } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

interface IStepsWrapperTitleProps {
  helmet?: string | ReactNode
}
const StepsWrapperTitle = ({ helmet }:IStepsWrapperTitleProps) => {
  if (helmet) {
    if (typeof helmet === 'string') {
      return (
         <HelmetProvider>
            {helmet && (
            <Helmet>
               <title>
                  {helmet}
                  {' '}
                  | BevNET.com
               </title>
            </Helmet>
            )}
         </HelmetProvider>
      );
    }
    return (
       <HelmetProvider>
          {helmet && (
          <Helmet>
             {helmet}
          </Helmet>
          )}
       </HelmetProvider>
    );
  }
  return null;
};

export default StepsWrapperTitle;
